import { graphql } from "@/data-access/graphql";

export const UploadLayoutTemplateAssetMutationString = `
  mutation uploadLayoutTemplateAsset($file: Upload!) {
    uploadLayoutTemplateAsset(file: $file) {
      ... on TemplateLayoutAsset {
        __typename
        assetId
        url
      }
      ... on OperationInfo {
        __typename
        messages {
          code
          field
          kind
          message
        }
      }
    }
  }
`;

/**
 * left, top, width, and height are fractions (0 to 1) of the image. targetWidth scales the
 * crop down to that many pixels wide. Only resizes declare it, so crops still pass validation
 * on servers that lack the argument.
 */
export const cropLayoutTemplateAssetMutationString = (
  withTargetWidth: boolean,
) => `
  mutation cropLayoutTemplateAsset(
    $assetId: ID!
    $left: Float!
    $top: Float!
    $width: Float!
    $height: Float!${withTargetWidth ? "\n    $targetWidth: Int!" : ""}
  ) {
    cropLayoutTemplateAsset(
      assetId: $assetId
      left: $left
      top: $top
      width: $width
      height: $height${withTargetWidth ? "\n      targetWidth: $targetWidth" : ""}
    ) {
      ... on TemplateLayoutAsset {
        __typename
        assetId
        url
      }
      ... on OperationInfo {
        __typename
        messages {
          code
          field
          kind
          message
        }
      }
    }
  }
`;

export const IngestLayoutTemplateAssetFromUrl = graphql(`
  mutation ingestLayoutTemplateAssetFromUrl($url: String!) {
    ingestLayoutTemplateAssetFromUrl(url: $url) {
      ... on TemplateLayoutAsset {
        __typename
        assetId
        url
      }
      ... on OperationInfo {
        __typename
        messages {
          code
          field
          kind
          message
        }
      }
    }
  }
`);
